import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { Section } from './Section';
import { faqs } from '../data/faqs';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <Section background="white" labelledBy="faq-heading" data-id="element-111" data-mp="1lck1mo86m85y">
      <h2 id="faq-heading" className="text-center font-serif text-[27px] font-semibold leading-[1.15] text-ink sm:text-3xl lg:text-[40px]" data-id="element-112" data-mp="1gcxoeescsrx5">
        Questions, answered
      </h2>

      <ul className="mx-auto mt-12 max-w-3xl divide-y divide-sage/15 border-y border-sage/15" data-id="element-113" data-mp="290tm9mtnspvi">
        {faqs.map((faq, index) => {
        const isOpen = open === index;
        return <li key={faq.q} data-id="element-114" data-mp="1z3fe0ahw37ea" data-mpi={index}>
              <h3 data-id="element-115" data-mp="1z2dt7eb2n6jd">
                <button type="button" aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} id={`faq-trigger-${index}`} onClick={() => setOpen(isOpen ? null : index)} className="flex w-full items-start justify-between gap-6 py-5 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sage" data-id="element-116" data-mp="1z2xbwx8jpyyg">
                  <span className="font-sans text-[16px] font-semibold leading-snug text-ink sm:text-[17px]" data-id="element-117" data-mp="fk0cauazo108">
                    {faq.q}
                  </span>
                  <ChevronDownIcon className={`mt-0.5 h-5 w-5 shrink-0 text-sage transition-transform duration-200 ease-out motion-reduce:transition-none ${isOpen ? 'rotate-180' : ''}`} strokeWidth={1.75} aria-hidden="true" data-id="element-118" data-mp="kkxv993toz2s" />
                </button>
              </h3>

              <div id={`faq-panel-${index}`} role="region" aria-labelledby={`faq-trigger-${index}`} className={`grid overflow-hidden transition-[grid-template-rows] duration-[220ms] ease-out motion-reduce:transition-none ${isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`} data-id="element-119" data-mp="1smy7vvunvcl">
                <div className="overflow-hidden" data-id="element-120" data-mp="1pojoaxxd2y04">
                  <p className="pb-6 pr-10 font-sans text-[16px] leading-[1.65] text-ink-soft" data-id="element-121" data-mp="1kqrtnw5c0xs8">
                    {faq.a}
                  </p>
                </div>
              </div>
            </li>;
      })}
      </ul>
    </Section>;
}